import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { IconButtonProps } from 'components/IconButton';

import { IconButton } from 'components/IconButton';
import { Icon } from 'components/Icon';

const codeString = `<IconButton variant={variant} aria-label={aria-label} onClick={onClickFunction}>
  <Icon name={iconName} size={size} />
  </IconButton>`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/IconButton',
  component: IconButton,
  argTypes: {
    variant: {
      options: ['destructive'],
      control: { type: 'check' },
    },
    noBorder: {
      control: 'boolean',
      default: false,
    },
    wide: {
      control: 'boolean',
      default: false,
    },
    'aria-label': {
      table: {
        disable: true,
      },
    },
    type: {
      options: ['button', 'submit', 'reset'],
      control: { type: 'select' },
    },
    children: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: IconButton,
    codeString: codeString,
  },
} as Meta<IconButtonProps>;

const Template: StoryFn<IconButtonProps> = (args) => {
  // args.variant is provided as an array because the control type is set to a checkbox. So this transforms the selected value into its proper value: a string
  const variantArray = (args.variant as unknown as string[]) ?? [];
  const iconButtonArgs = { ...args, ...{ variant: variantArray.toString() } } as IconButtonProps;

  return <IconButton {...iconButtonArgs} />;
};

export const IconButtonExample = Template.bind({});
IconButtonExample.args = {
  'aria-label': 'Trash',
  variant: 'destructive',
  noBorder: false,
  wide: false,
  disabled: false,
  children: <Icon name="Trash" />,
  onClick: fn(),
};
